import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Select,
  MenuItem,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Breadcrumbs,
  Link,
  Chip,
  Stack,
  Snackbar,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import {
  encryptText,
  encryptAppId,
  decryptText,
  decryptAppId,
} from "../../utils/encryption";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const { generateDecisionLetter } = await import('./../certificate/DecisionLetterGenerator');



const ILACPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to get orgId from URL query parameters with decryption
  const getOrgIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedOrgId = searchParams.get("orgId");
    if (encryptedOrgId) {
      try {
        const decryptedOrgId = decryptText(encryptedOrgId);
        return decryptedOrgId;
      } catch (error) {
        return encryptedOrgId;
      }
    }
    return null;
  };

  // Function to get appId from URL query parameters with decryption
  const getAppIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedAppId = searchParams.get("appId");
    if (encryptedAppId) {
      try {
        const decryptedAppId = decryptAppId(encryptedAppId);
        return decryptedAppId;
      } catch (error) {
        return encryptedAppId;
      }
    }
    return null;
  };

  const getLabTypeIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedLabTypeId = searchParams.get("labTypeId");
    if (encryptedLabTypeId) {
      try {
        const decryptedLabTypeId = decryptAppId(encryptedLabTypeId);
        return decryptedLabTypeId;
      } catch (error) {
        return encryptedLabTypeId;
      }
    }
    return null;
  };

  const getOrgId = () => {
    const queryOrgId = getOrgIdFromQuery();
    if (queryOrgId) {
      return queryOrgId;
    }
    return null;
  };

  const getAppId = () => {
    const queryAppId = getAppIdFromQuery();
    if (queryAppId) {
      return queryAppId;
    }
    return null;
  };

  const getLabTypeId = () => {
    const queryLabTypeId = getLabTypeIdFromQuery();
    if (queryLabTypeId) {
      return queryLabTypeId;
    }
    return null;
  };

  const [orgId, setOrgId] = useState(getOrgId());
  const [appId, setAppId] = useState(getAppId());
  const [labTypeId, setLabTypeId] = useState(getLabTypeId());
  const [userTypeId, setUserTypeId] = useState(
    localStorage.getItem("userTypeId") || ""
  );
  const [loading, setLoading] = useState(true);
  const [ilacData, setIlacData] = useState(null);
  const [certDetails, setCertDetails] = useState(null);
  const [proceedStatus, setProceedStatus] = useState({});
  const [jdRemarks, setJdRemarks] = useState([]);
  const [jdList, setJdList] = useState([]);
  const [stage, setStage] = useState("");
  const [doReplyStatus, setDoReplyStatus] = useState(null);
  const [acceptSubject, setAcceptSubject] = useState(
    "Grant of permission to use NABL Accredited CAB Combined ILAC MRA Mark",
  );
  const [acceptBody, setAcceptBody] =
    useState(`The permission to use NABL Accredited CAB Combined ILAC MRA Mark is being granted to your laboratory as per the following details.<br/><br/>

<strong>CAB ID -</strong> <br/>
<strong>CAB Name -</strong> <br/>
<strong>Certificate No. -</strong> <br/>
<strong>Accreditation Validity -</strong> <br/>
<strong>Permission Valid Till -</strong><br/><br/>

Please note that the permission to use the NABL Accredited CAB Combined ILAC MRA Mark on reports/certificates will expire on ________.<br/><br/>

You are required to stop the use of the NABL Accredited CAB Combined ILAC MRA Mark on reports/certificates after ________ and obtain fresh permission to continue using the NABL Accredited CAB Combined ILAC MRA Mark on reports/certificates beyond the validity period.<br/><br/>

<strong>Note:</strong><br/><br/>

1. Use of the NABL Accredited CAB Combined ILAC MRA Mark without written permission from NABL is strictly prohibited. If found otherwise, strict adverse action will be initiated against the laboratory by NABL.<br/><br/>

2. NABL Accredited CAB Combined ILAC MRA Mark shall be used only on reports/certificates. It cannot be used on letterheads, promotional brochures, websites, etc. For more details, please refer to the latest NABL 133 document.<br/><br/>
`);

const [rejectSubject, setRejectSubject] = useState(
    "Denial of permission to use NABL Accredited CAB Combined ILAC MRA Mark",
  );
  const [rejectBody, setRejectBody] =
    useState(`
The permission to use NABL Accredited CAB Combined ILAC MRA Mark has been denied to your laboratory due to the following reason(s).<br/><br/><br/>

<strong>Note:</strong><br/><br/>

1. Use of the NABL Accredited CAB Combined ILAC MRA Mark without written permission from NABL is strictly prohibited. If found otherwise, strict adverse action will be initiated against the laboratory by NABL.
`);

  // Form states
  const [formData, setFormData] = useState({
    cabName: "",
    cabId: "",
    certNo: "",
    issueDate: "",
    validDate: "",
    address: "",
    remark: "",
    headOfLab: "",
    designation: "",
    doRemarks: "",
    isComplaint: "",
    complaintRemarks: "",
    submittedDate: "",
  });

  // Decision Letter states
  const [decisionLetter, setDecisionLetter] = useState({
    id: "",
    subject: "",
    body: "",
    remarks: "",
    rejectedRemarks: "",
    isActive: "",
    isSent: "",
    isApproved: "",
  });

  // Dialog states
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [passwordAction, setPasswordAction] = useState("");
  const [password, setPassword] = useState("");
  const [selectedJD, setSelectedJD] = useState("");
  const [acceptRemarks, setAcceptRemarks] = useState("");
  const [rejectRemarks, setRejectRemarks] = useState("");

  // Alert states
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // Visibility states
  const [visibility, setVisibility] = useState({
    showCABActions: true,
    showSendComplaint: false,
    showComplaintSection: false,
    showDORemarks: true,
    showAcceptReject: false,
    showDecisionPanel: false,
    showProceedButton: false,
    showSendAgainButton: false,
    showCancelProceed: false,
    showSubmitButton: false,
    showJDRemarks: false,
  });

  // Snackbar State
    const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "info",
    });
  
    const showSnackbar = (message, severity = "info") => {
      setSnackbar({ open: true, message, severity });
    };
  
    const handleCloseSnackbar = () => {
      setSnackbar({ ...snackbar, open: false });
    };
  

  useEffect(() => {
    if (appId) {
      fetchAllData();
    }
  }, [appId]);

  // Separate effect for visibility updates after data is loaded
  useEffect(() => {
    if (!loading && ilacData) {
      if (userTypeId === "4") {
        updateVisibilityForDO();
      } else {
        updateVisibilityForCAB();
      }
    }
  }, [loading, ilacData, proceedStatus, doReplyStatus, stage, userTypeId, jdRemarks, decisionLetter]);

  const fetchAllData = async () => {
    try {
      setLoading(true);

      // Fetch ILAC data
      const ilacResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/data/${appId}/${orgId}`
      );
      if (ilacResponse.data.success && ilacResponse.data.data) {
        const data = ilacResponse.data.data;
        setIlacData(data);
        setFormData((prev) => ({
          ...prev,
          headOfLab: data.Name || "",
          designation: data.Designation || "",
          submittedDate: data.SubmitDate || "",
          isComplaint: data.IsComplaint? Array.isArray(data.IsComplaint) ? data.IsComplaint[0] : data.IsComplaint : "" || "",
          complaintRemarks: data.CCell_Remarks || "",
        }));

        // Set stage
        if (data.stage) {
          setStage(data.stage);
        }
      }

      // Fetch get-ILAC-basic-info details
      const basicInfoResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/get-ILAC-basic-info/${appId}`
      );
      if (basicInfoResponse.data.success && basicInfoResponse.data.data) {
        const infoData = basicInfoResponse.data.data;
        setFormData((prev) => ({
          ...prev,
          cabName: infoData.cabname || '',
          cabId: infoData.ApplicationNo || '',
          certNo: infoData.cert_no || '',
          issueDate: formatToInputDate(infoData.IssueDate) || '',
          validDate: formatToInputDate(infoData.ValidDate) || '',
          address: infoData.LabAddress || '',
          remark: infoData.Remark || ''
        }));
      }

      // Fetch check ILAC details
      const checkILACDetialsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/check-ilac-details/${appId}`
      );
      if (checkILACDetialsResponse.data.success) {
        setVisibility((prev) => ({
          ...prev,
          showSubmitButton: true,
        }));
      }else{
        setVisibility((prev) => ({
          ...prev,
          showSubmitButton: false,
        }));
       }
      // Fetch certificate details
      const certResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/certificate/${appId}`
      );
      if (certResponse.data.success && certResponse.data.data) {
        const certData = certResponse.data.data;
        setCertDetails(certData);
      }

      // Fetch proceed status
      const proceedResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/proceed-status/${appId}`
      );
      if (proceedResponse.data.success && proceedResponse.data.data) {
        setProceedStatus(proceedResponse.data.data);
      }

      // Fetch DO reply status
      const doReplyResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/ilac/do-reply-status/${appId}`
      );
      if (doReplyResponse.data.success && doReplyResponse.data.data) {
        setDoReplyStatus(doReplyResponse.data.data);
      }

      // If user is DO (userTypeId === "4")
      if (userTypeId === "4") {
        // Fetch JD remarks
        const jdRemarksResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/ilac/jd-remarks/${appId}`
        );
        if (jdRemarksResponse.data.success && jdRemarksResponse.data.data) {
          setJdRemarks(jdRemarksResponse.data.data);
        }

        // Fetch decision letter
        const decisionResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/ilac/decision-letter/${appId}`
        );
        if (decisionResponse.data.success && decisionResponse.data.data) {
          const decData = decisionResponse.data.data;
          setDecisionLetter((prev) => ({
            id: decData.id || "",
            subject: decData.Subject || (doReplyResponse.data.data && doReplyResponse.data.data?.do_reply === 1 ? acceptSubject : rejectSubject) || "",
            body: decData.Body || (doReplyResponse.data.data && doReplyResponse.data.data?.do_reply === 1 ? acceptBody : rejectBody) || "",
            remarks: decData.Remarks || "",
            rejectedRemarks: decData.ApproveRemarks || "",
            isActive: decData.isactive || "",
            isSent: decData.IsSent || "",
            isApproved: decData.Isapproved || "",
          }));
          setFormData((prev) => ({
          ...prev,
          doRemarks: decData.doRemark || "",
        }));
        }

        // Fetch JD list
        const jdListResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/ilac/jd-list/${labTypeId}/${orgId}`
        );
        if (jdListResponse.data.success && jdListResponse.data.data) {
          setJdList(jdListResponse.data.data);
        }
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const updateVisibilityForDO = () => {
    const currentStage = stage;
    const proceedClick = proceedStatus?.ProceedClick || "0";
    const sendAgainClick = proceedStatus?.Sendagaineventclick || "0";
    const doReply = doReplyStatus?.do_reply || "";

    let newVisibility = {
      showCABActions: false,
      showSendComplaint: false,
      showComplaintSection: false,
      showDORemarks: true,
      showAcceptReject: false,
      showDecisionPanel: false,
      showProceedButton: false,
      showSendAgainButton: false,
      showCancelProceed: false,
      showSubmitButton: false,
      showJDRemarks: jdRemarks.length > 0,
      showSendToNABL: false,
    };

    // Stage 15 or 15aa - Send to complaint team
    if (currentStage === "15") {
      newVisibility.showSendComplaint = true;
      newVisibility.showDORemarks = false;
      newVisibility.showAcceptReject = false;
    } else if (currentStage === "15aa") {
      newVisibility.showComplaintSection = true;
      newVisibility.showDORemarks = false;
      newVisibility.showAcceptReject = false;
      
      // Check proceed status for 15aa
      if (proceedClick === 0) {
        newVisibility.showProceedButton = true;
        newVisibility.showSendAgainButton = true;
      } else if (proceedClick === 1) {
        newVisibility.showAcceptReject = true;
        newVisibility.showCancelProceed = true;
        newVisibility.showDORemarks = true;
      }

      // Hide complaint section if sent again
      if (sendAgainClick === 1) {
        newVisibility.showComplaintSection = false;
        newVisibility.showSendComplaint = false;
      }
    } 
    // Stage 15b, 15bb - DO Accept/Reject
    else if (currentStage === "15b" || currentStage === "15bb") {
      if (doReply === "") {
        newVisibility.showComplaintSection = true;
        newVisibility.showAcceptReject = true;
        newVisibility.showDORemarks = true;
      } else if (doReply === 1 || doReply === 2) {
        newVisibility.showComplaintSection = true;
        newVisibility.showDecisionPanel = true;
        newVisibility.showAcceptReject = false;
      }
    }
    // Stage 15a - After decision
    else if (currentStage === "15a") {
      newVisibility.showDecisionPanel = true;
      newVisibility.showDORemarks = false;
      newVisibility.showSendToNABL = decisionLetter.isSent === 1 && decisionLetter.isApproved === 1;
    }

    setVisibility(newVisibility);
  };

  const updateVisibilityForCAB = () => {
    if(stage){
      setVisibility((prev) => ({
        ...prev,
        showCABActions: false,
      }));
    }else{
    setVisibility((prev) => ({
      ...prev,
      showCABActions: true,
    }));
   }
  };

  const formatToInputDate = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr.includes("-")) {
      return dateStr.split("T")[0];
    }
    if (dateStr.includes("/")) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDecisionChange = (e) => {
    const { name, value } = e.target;
    setDecisionLetter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showAlert = (message, severity = "info") => {
    setAlert({ open: true, message, severity });
    setTimeout(
      () => setAlert({ open: false, message: "", severity: "info" }),
      5000
    );
  };

  const handleSaveBasicInfo = async () => {
    if (!formData.cabName || !formData.cabId || !formData.certNo || !formData.issueDate || !formData.validDate || !formData.address) {
      showAlert("Please fill all required fields", "warning");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/save-basic-info`,
        {
          name: formData.cabName,
          applicationNo: formData.cabId,
          certNo: formData.certNo,
          issueDate: formData.issueDate,
          validDate: formData.validDate,
          labAddress: formData.address,
          remark: formData.remark,
          appId,
          orgId,
        }
      );

      if (response.data.success) {
        showAlert("Data saved successfully", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error saving basic info:", error);
      showAlert("Error saving basic info", "error");
    }
  };

  const handleSaveRemark = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/save-remark`,
        {
          appId,
          remark: formData.remark,
        }
      );

      if (response.data.success) {
        showAlert("Remark saved successfully", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error saving remark:", error);
      showAlert("Error saving remark", "error");
    }
  };

  const handleSaveComplaintDetails = async () => {
    if (!formData.isComplaint || !formData.complaintRemarks) {
      showAlert("Please fill all complaint details", "warning");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/save-complaint`,
        {
          appId,
          isComplaint: formData.isComplaint,
          cCellRemarks: formData.complaintRemarks,
        }
      );

      if (response.data.success) {
        showAlert("Complaint details saved successfully", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error saving complaint details:", error);
      showAlert("Error saving complaint details", "error");
    }
  };

  const handleSaveCABDetails = async () => {
    if (!formData.headOfLab || !formData.designation) {
      showAlert("Please fill all required fields", "warning");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/save-cab-details`,
        {
          name: formData.headOfLab,
          designation: formData.designation,
          appId,
          orgId,
          stateName: ilacData?.StateName || "",
          cityName: ilacData?.CityName || "",
          applicationNo: formData.cabId,
          cabname: formData.cabName,
        }
      );

      if (response.data.success) {
        showAlert("CAB details saved successfully", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error saving CAB details:", error);
      showAlert("Error saving CAB details", "error");
    }
  };

  const handleOpenPasswordDialog = (action) => {
    setPasswordAction(action);
    setOpenPasswordDialog(true);
  };

  const handleClosePasswordDialog = () => {
    setOpenPasswordDialog(false);
    setPassword("");
    setSelectedJD("");
    setAcceptRemarks("");
    setRejectRemarks("");
  };

  const handlePasswordAction = async () => {
    if (!password) {
      showAlert("Please enter password", "warning");
      return;
    }

    try {
      let response;
      const apiUrl = process.env.REACT_APP_API_URL;

      switch (passwordAction) {
        case "submit":
          response = await axios.post(`${apiUrl}/ilac/submit-final`, {
            orgId,
            appId,
          });
          break;

        case "proceed":
          response = await axios.post(`${apiUrl}/ilac/proceed`, {
            appId,
            password,
          });
          break;

        case "sendAgain":
          response = await axios.post(`${apiUrl}/ilac/send-again-complaint`, {
            appId,
            password,
            orgId,
          });
          break;

        case "cancelProceed":
          response = await axios.post(`${apiUrl}/ilac/cancel-proceed`, {
            appId,
          });
          break;

        case "forwardToJD":
          if (!selectedJD) {
            showSnackbar("Please select Joint Director", "warning");
            return;
          }
          response = await axios.post(`${apiUrl}/ilac/forward-to-jd`, {
            appId,
            orgId: localStorage.getItem("orgId"),
            sentTo: selectedJD,
            id: decisionLetter.id,
          });
          break;

        case "accept":
          if (!acceptRemarks) {
            showSnackbar("Please enter remarks", "warning");
            return;
          }
          response = await axios.post(`${apiUrl}/ilac/do-accept`, {
            appId,
            orgId: localStorage.getItem("orgId"),
            doRemarks: formData.doRemarks,
            remarks: acceptRemarks,
          });
          break;

        case "reject":
          if (!rejectRemarks) {
            showSnackbar("Please enter required remarks", "warning");
            return;
          }
          response = await axios.post(`${apiUrl}/ilac/do-reject`, {
            appId,
            labTypeId: labTypeId,
            reply: rejectRemarks,
            doRemarks: formData.doRemarks,
          });
          break;

        case "rollback":
          response = await axios.post(`${apiUrl}/ilac/rollback-decision`, {
            appId,
            orgId: localStorage.getItem("orgId"),
          });
          break;

        case "sendToNABL":
          response = await axios.post(`${apiUrl}/ilac/send-to-nabl`, {
            appId,
          });
          break;

        default:
          break;
      }

      if (response?.data.success) {
        showSnackbar(response.data.message || "Action completed successfully", "success");
        if (passwordAction === "submit") {
          // Send lab submission notification email
          const response = await axios.post(`${apiUrl}/assessment-mail/send-lab-submission-notification`,
          { appId: appId, orgId: orgId } );
          console.log(response.data);
        }
        handleClosePasswordDialog();
        fetchAllData();
        if (passwordAction === "rollback") {
          setTimeout(() => {
          window.location.reload();
        }, 2000);
        }
      }
    } catch (error) {
      console.error("Error in password action:", error);
      showSnackbar(
        error.response?.data?.message || "Error performing action",
        "error"
      );
    }
  };

  const handleSendToComplaintTeam = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/send-to-complaint-team`,
        {
          appId,
          orgId,
        }
      );

      if (response.data.success) {
        showSnackbar("Successfully sent to complaint team", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error sending to complaint team:", error);
      showSnackbar("Error sending to complaint team", "error");
    }
  };

  const handleSaveDecisionLetter = async () => {
    if (!decisionLetter.subject || !decisionLetter.body) {
      showSnackbar("Please fill subject and decision body", "warning");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/ilac/save-acceptance-letter`,
        {
          appId,
          orgId: localStorage.getItem("orgId"),
          subject: decisionLetter.subject,
          body: decisionLetter.body,
          remarks: decisionLetter.remarks,
          type: doReplyStatus?.do_reply === 1 ? "Accept" : "Reject",
          id: decisionLetter.id,
          actionType: decisionLetter.id ? "Update" : "Save",
        }
      );

      if (response.data.success) {
        showSnackbar("Decision letter saved successfully", "success");
        fetchAllData();
      }
    } catch (error) {
      console.error("Error saving decision letter:", error);
      showSnackbar("Error saving decision letter", "error");
    }
  };

  const handleViewLetter = async () => {
    try {
      showSnackbar("Generating decision letter...", "info");
      const decisionResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/ilac/decision-letter/${appId}`
        );
        if (decisionResponse.data.success && decisionResponse.data.data) {
          const decisionLetter = decisionResponse.data.data;
      // Check if application data is available
      if (!decisionLetter) {
        showSnackbar(
          "Decision letter data not loaded. Please wait and try again.",
          "warning",
        );
        return;
      }
      // Prepare letter data
      const letterData = {
        applicationNo: decisionLetter.ApplicationNo || "N/A",
        letterDate: decisionLetter.DecisionDate ? formatDecisionDate(decisionLetter.DecisionDate) : "N/A",
        contactPerson: decisionLetter.ContactPerson || "N/A",
        laboratoryName: decisionLetter.LabName || "N/A",
        address: decisionLetter.Address || "N/A",
        extAddress: decisionLetter.Extaddress || "N/A",
        mobile: decisionLetter.ContactMobile || "N/A",
        email: decisionLetter.ContactEmail || "N/A",
        subject: decisionLetter.Subject || "N/A",
        body: decisionLetter.Body || "N/A",
        doName: decisionLetter.doName || "N/A",
        doEmail: decisionLetter.MailBy || "N/A",
        showAdverseNote: false,
        showNewAddress: new Date() > new Date("2025-07-18"),
      };
      console.log("Prepared letter data:", letterData);
      // Generate PDF
      await generateDecisionLetter(letterData);
      showSnackbar("Decision letter downloaded successfully", "success");
     }
    } catch (err) {
      console.error("Error generating letter:", err);
      showSnackbar("Failed to generate decision letter", "error");
    }
  };

  const formatDecisionDate = (dateString) => {
    if (!dateString) return "N/A";
    const formatted = dateString.replace("AM", " AM").replace("PM", " PM");
    const date = new Date(formatted);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const termsAndConditions = [
    "The accredited CAB shall use the NABL Accredited CAB Combined ILAC MRA Mark only after this agreement has been signed by NABL accredited CAB and NABL.",
    "Accredited CABs can use the NABL Accredited CAB Combined ILAC MRA Mark for activities undertaken outside the economy in which they are established.",
    "The accredited CAB shall ensure that, at all times, its use of the NABL Accredited CAB Combined ILAC MRA Mark does not breach any requirements of NABL 133.",
    "NABL Accredited CAB Combined ILAC MRA Mark shall only be reproduced in the manner prescribed in Section 9 of NABL 133.",
    "The ILAC MRA Mark shall be positioned at the left side of the NABL symbol, but shall appear in close proximity to each other.",
    "NABL accredited CAB shall not use the NABL Accredited CAB Combined ILAC MRA Mark in any way that would harm the reputation of ILAC and/or NABL.",
    "NABL accredited CAB shall allow NABL to observe the use of the Accredited CAB Combined ILAC MRA Mark.",
    "NABL accredited CABs are entitled to use of the NABL Accredited CAB Combined ILAC MRA Mark together with the certificate number of the accredited CAB.",
    "NABL accredited CAB shall not use the ILAC MRA Mark in any form other than as part of a NABL Accredited CAB Combined ILAC MRA Mark.",
    "Upon the termination of this agreement, the accredited CAB no longer has the right to use the NABL Accredited CAB Combined ILAC MRA Mark and stop all such use.",
    'The accredited CAB\'s rights under this agreement shall automatically and immediately be suspended during any period where the accredited CAB either voluntary withdraws its Accreditation or the accreditation status of the CAB is under "Voluntary Withdrawal" or "Suspension" or "Forced Withdrawal" or "Debarred" category.',
    "NABL has the right to terminate this agreement by giving a written notice if the accredited CAB is found violating the terms and conditions of this agreement.",
    "This agreement will automatically terminate when CAB Acquisition, Merger, De-Merger, Take over/ Purchase and Selling of CAB has been initiated as informed to NABL.",
    "This agreement will automatically terminate when ILAC MRA status of NABL has been suspended, terminated or not renewed by ILAC.",
    "In case, there is any on-going complaint against the accredited CAB, NABL shall not permit the use of NABL Accredited CAB Combined ILAC MRA Mark to the particular CAB.",
    "All disputes, if any, arising out of this contract, that remain unresolved through mechanism provided by NABL are subject to the exclusive jurisdiction of the Courts at New Delhi and none other.",
  ];

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f8fafc", pb: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: "linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)",
          color: "white",
          borderRadius: 0,
          mb: 3,
        }}
      >
        <Box sx={{ px: 3, py: 3 }}>
          <Breadcrumbs
            sx={{
              mb: 2,
              "& .MuiBreadcrumbs-separator": { color: "rgba(255,255,255,0.7)" },
            }}
          >
            <Link
              component="button"
              variant="body2"
              onClick={handleBackClick}
              sx={{
                textDecoration: "none",
                color: "rgba(255,255,255,0.8)",
                "&:hover": { color: "white" },
              }}
            >
              Applications
            </Link>
            <Typography variant="body2" sx={{ color: "white" }}>
              Appendix A of NABL 133
            </Typography>
          </Breadcrumbs>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                Agreement for use of NABL Accredited CAB Combined ILAC MRA Mark
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleBackClick}
              sx={{
                borderColor: "rgba(255,255,255,0.3)",
                color: "white",
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* Alert */}
      {alert.open && (
        <Box sx={{ px: 3, mb: 2 }}>
          <Alert
            severity={alert.severity}
            onClose={() => setAlert({ ...alert, open: false })}
          >
            {alert.message}
          </Alert>
        </Box>
      )}

      <Box sx={{ px: 3 }}>
        {/* Certificate Details */}
        <Card elevation={3} sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Certificate Details
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="CAB Name"
                  name="cabName"
                  value={formData.cabName || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="CAB ID"
                  name="cabId"
                  value={formData.cabId || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Certificate Number"
                  name="certNo"
                  value={formData.certNo || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Issue Date"
                  name="issueDate"
                  type="date"
                  value={formData.issueDate || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Valid upto"
                  name="validDate"
                  type="date"
                  value={formData.validDate || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formData.address || ""}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  multiline
                  rows={2}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Remark"
                  name="remark"
                  value={formData.remark || ""}
                  onChange={handleInputChange}
                  multiline
                  rows={3}
                  variant="outlined"
                />
              </Grid>
              {visibility.showCABActions && (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleSaveBasicInfo}
                  >
                    Save
                  </Button>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>

        {/* Terms and Conditions */}
        <Card elevation={3} sx={{ mb: 3 }}>
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, textAlign: "center", mb: 3 }}
            >
              Terms and Conditions for Use of NABL Accredited CAB Combined ILAC
              MRA Mark
            </Typography>
            <Box component="ol" type="A" sx={{ pl: 2 }}>
              {termsAndConditions.map((term, index) => (
                <Box component="li" key={index} sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ textAlign: "justify" }}>
                    {term}
                  </Typography>
                </Box>
              ))}
            </Box>
          </CardContent>
        </Card>

        {/* Declaration */}
        <Card elevation={3} sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Declaration
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Typography variant="body2" paragraph>
              I declare that, undersigned is authorized to sign this agreement
              on behalf of{" "}
              <strong>
                {formData.cabName}, ({formData.cabId})
              </strong>{" "}
              which is accredited by NABL in the field of{" "}
              <strong>
                {ilacData?.ApplicationType ||
                  "(Testing / Calibration / Medical / PTP / RMP)"}
              </strong>
              .
            </Typography>
          </CardContent>
        </Card>

        {/* Authorized Representative of CAB */}
        <Card elevation={3} sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Authorised Representative of CAB
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Name of Head of the Laboratory"
                  name="headOfLab"
                  value={formData.headOfLab || ""}
                  onChange={handleInputChange}
                  disabled={userTypeId === "4"}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Designation"
                  name="designation"
                  value={formData.designation || ""}
                  onChange={handleInputChange}
                  disabled={userTypeId === "4"}
                  required
                />
              </Grid>
              {formData.submittedDate && (
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Submitted Date:
                  </Typography>
                  <Typography variant="body1" fontWeight={500}>
                    {formData.submittedDate}
                  </Typography>
                </Grid>
              )}
            </Grid>

            {visibility.showCABActions && (
              <Box sx={{ mt: 3, textAlign: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveCABDetails}
                  sx={{ mr: 2 }}
                >
                  Save
                </Button>
                {visibility.showSubmitButton && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => handleOpenPasswordDialog("submit")}
                  >
                    Submit
                  </Button>
                )}
              </Box>
            )}
          </CardContent>
        </Card>

        {/* JD Remarks (for DO) */}
        {visibility.showJDRemarks && jdRemarks.length > 0 && (
          <Card elevation={3} sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                Rejected Remarks By Joint Director
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No.</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Rejected Remarks</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {jdRemarks.map((remark, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{remark.ApproveDate}</TableCell>
                        <TableCell>{remark.ApproveRemarks}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        )}

        {/* Send to Complaint Team */}
        {visibility.showSendComplaint && (
          <Box sx={{ mb: 3, textAlign: "center" }}>
            <Button
              variant="contained"
              color="info"
              onClick={handleSendToComplaintTeam}
              sx={{ width: 300 }}
            >
              Send to Complaints Team for confirmation
            </Button>
          </Box>
        )}

        {/* Complaint Details (for DO) */}
        {visibility.showComplaintSection && (
          <Card elevation={3} sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                Complaint Details
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      Whether there is any ongoing complaint against CAB *'
                      <Typography
                        variant="caption"
                        display="block"
                        color="primary"
                      >
                        (Please mark confirmation from Complaint Cell)
                      </Typography>
                    </FormLabel>
                    <RadioGroup
                      row
                      name="isComplaint"
                      value={formData.isComplaint}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Yes"
                        disabled
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="No"
                        disabled
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Enter Remark(s) *"
                    name="complaintRemarks"
                    value={formData.complaintRemarks}
                    multiline
                    rows={3}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2} justifyContent="center">
                    {visibility.showProceedButton && (
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleOpenPasswordDialog("proceed")}
                      >
                        Proceed
                      </Button>
                    )}
                    {visibility.showSendAgainButton && (
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={() => handleOpenPasswordDialog("sendAgain")}
                      >
                        Send Again
                      </Button>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        {/* DO Remarks and Accept/Reject (for DO) */}
        {visibility.showDORemarks && userTypeId === "4" && (
          <Card elevation={3} sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                Additional Information
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Additional Information (If Any)"
                    name="doRemarks"
                    value={formData.doRemarks}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    helperText="(e.g. Form 26C, etc.)"
                    disabled={formData.doRemarks && doReplyStatus}
                  />
                </Grid>

                {visibility.showAcceptReject && (
                  <Grid item xs={12}>
                    <Stack direction="row" spacing={2} justifyContent="center">
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<CheckCircleIcon />}
                        onClick={() => handleOpenPasswordDialog("accept")}
                      >
                        Accept
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        startIcon={<CancelIcon />}
                        onClick={() => handleOpenPasswordDialog("reject")}
                      >
                        Reject
                      </Button>
                      {visibility.showCancelProceed && (
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={() =>
                            handleOpenPasswordDialog("cancelProceed")
                          }
                        >
                          Cancel Proceed
                        </Button>
                      )}
                    </Stack>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        )}

        {/* Decision Letter Panel (for DO) */}
        {visibility.showDecisionPanel && (
          <Card elevation={3} sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                Decision Letter
              </Typography>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Subject"
                    name="subject"
                    value={decisionLetter.subject}
                    onChange={handleDecisionChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Enter Decision Body *
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      minHeight: 300,
                    }}
                  >
                    <ReactQuill
                      theme="snow"
                      value={decisionLetter.body}
                      onChange={(value) =>
                        setDecisionLetter((prev) => ({
                          ...prev,
                          body: value,
                        }))
                      }
                      style={{ height: 250 }}
                      required
                    />
                  </Box>
                </Grid>
                {decisionLetter.rejectedRemarks && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Rejected Remarks"
                      value={decisionLetter.rejectedRemarks}
                      disabled
                      multiline
                      rows={2}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    flexWrap="wrap"
                  >
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleSaveDecisionLetter}
                    >
                      {decisionLetter.isActive===1 ? "Update" : "Save"}
                    </Button>
                    {decisionLetter.isActive===1 && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleViewLetter}
                        >
                          View Decision
                        </Button>
                        {decisionLetter.isSent !== 1 && (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleOpenPasswordDialog("forwardToJD")
                              }
                            >
                              Forward to JD
                            </Button>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() =>
                                handleOpenPasswordDialog("rollback")
                              }
                            >
                              Rollback Decision
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        {/* Send to NABL (for DO) */}
        {visibility.showSendToNABL && (
          <Box sx={{ mb: 3, textAlign: "center" }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => handleOpenPasswordDialog("sendToNABL")}
            >
              Send To NABL
            </Button>
          </Box>
        )}
      </Box>

      {/* Password Dialog */}
      <Dialog
        open={openPasswordDialog}
        onClose={handleClosePasswordDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {passwordAction === "submit" && "Final Submit"}
          {passwordAction === "proceed" &&
            "Application proceed for further process"}
          {passwordAction === "sendAgain" &&
            "Application send to Complaint cell for review"}
          {passwordAction === "cancelProceed" && "Cancel Proceed"}
          {passwordAction === "forwardToJD" &&
            "Send Application To Joint Director"}
          {passwordAction === "accept" && "Mark For Accept"}
          {passwordAction === "reject" && "Mark For Reject"}
          {passwordAction === "rollback" && "Rollback Decision"}
          {passwordAction === "sendToNABL" && "Send To NABL"}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            {passwordAction === "forwardToJD" && (
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel>Select Joint Director *</InputLabel>
                <Select
                  value={selectedJD}
                  onChange={(e) => setSelectedJD(e.target.value)}
                  label="Select Joint Director *"
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {jdList.map((jd) => (
                    <MenuItem key={jd.id} value={jd.id}>
                      {jd.dName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {passwordAction === "accept" && (
              <TextField
                fullWidth
                label="Remarks"
                value={acceptRemarks}
                onChange={(e) => setAcceptRemarks(e.target.value)}
                multiline
                rows={2}
                sx={{ mb: 3 }}
                required
              />
            )}

            {passwordAction === "reject" && (
              <TextField
                fullWidth
                label="Remarks *"
                value={rejectRemarks}
                onChange={(e) => setRejectRemarks(e.target.value)}
                multiline
                rows={2}
                sx={{ mb: 3 }}
                required
              />
            )}

            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus={passwordAction !== "forwardToJD"}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePasswordDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handlePasswordAction}
            variant="contained"
            color="success"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ILACPage;
